import React, { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { sanitize } from 'dompurify'
import { ModuleBody, ErrorBoundary } from '../'

interface IProps {
  title?: string
  className?: string
  moduleBodyClass?: string
  isNewLayout?: boolean
  children: any
}

const ModuleHeader: FC<IProps> = ({
  title,
  children,
  className,
  moduleBodyClass,
  isNewLayout,
}) =>
  title || children ? (
    <ErrorBoundary>
      <Box marginBottom={2} whiteSpace={['wrap', 'nowrap']}>
        {title && (
          <Typography
            variant="h1"
            dangerouslySetInnerHTML={{ __html: sanitize(title) }}
            className={className}
          />
        )}
      </Box>
      <Box marginBottom={1}>
        {children && (
          <ModuleBody classNames={moduleBodyClass} isNewLayout={isNewLayout}>
            {children}
          </ModuleBody>
        )}
      </Box>
    </ErrorBoundary>
  ) : null

export default ModuleHeader
